import React, {Component} from 'react'
import EmptyExploreImg from "../../assets/images/empty-explore.png";
import "./EmptyExplore.css";

export class EmptyExplore extends Component {
    render(){
        return (
            <div
                className='empty-explore-wrapper'
            >
                <img 
                    className='empty-explore-img'
                    src={EmptyExploreImg} 
                    alt="empty" 
                />
                <p
                    className='empty-explore-p'
                >
                    Aquí estarán tus archivos.<br/>Comienza subiendo uno
                </p>
            </div>
        )
    }
}

export default EmptyExplore;
